import { DataFromUrl, TRANSLATION, Yup, JOB_STAGES} from '@/imports-files/pages/clients/jobs/job-options';

export function getInitalValues(jobOwner, router, current_step){
  const jobId     =   new DataFromUrl().getJobId();

  const intialValue = {
    job: {
      id: jobId,
      step: current_step
    }
  }

  return intialValue;
}

export function getEditInitalOptionValues(job, current_step, current_jobOwner)
{
  var approvers = []
  var job_approvers = {}
  if(job.approvers.emails)
  {
    approvers = job.approvers;
    job_approvers.emails = approvers.emails
    job_approvers.initials = approvers.initials
    job_approvers.required_approvers = job.required_approvers
  }
  else if(job.approvers)
  {
    approvers = job.approvers;
    job_approvers.emails = approvers.map((x) => x.email)
    job_approvers.initials = approvers
    job_approvers.required_approvers = job.required_approvers
  }
  else{
    job_approvers = {emails: new Array(), initials: new Array(), required_approvers: ''}
  }

  let current_user_initials = [{
                            email: current_jobOwner?.user_attributes?.email,
                            name: current_jobOwner?.user_attributes?.name,
                            name_initials: current_jobOwner?.user_attributes?.name_initials,
                            photo_url: current_jobOwner?.user_attributes?.photo_url
  }]
  return { job :
    {
      id: job.id,
      step: current_step,
      hide_hiring: job.hide_hiring,
      hide_hiring_editable: job.hide_hiring_editable,
      daxtra_threshold: job.daxtra_threshold,
      hiring_manager_initials: job.hiring_manager_initials,
      job_owner_initials: job.job_owner_initials.length > 0 ? job.job_owner_initials : current_user_initials,
      job_owner_emails: job.job_owner_initials.length > 0 ? job.job_owner_initials.map((x) => x.email) : current_user_initials?.map((x) => x.email),
      hiring_manager_emails: job.hiring_manager_initials.map((x) => x.email),
      screening_questions_attributes: job.screening_questions_attributes,
      approvers: job_approvers
    }
  }
}

export function getValidationSchema(submitState, job_status){
  let validationRequired = !(submitState == 'draft' || (submitState == 'preview' && job_status != 'active'))
  if(validationRequired){
    return Yup.object().shape({
      job: Yup.object().shape({
        daxtra_threshold: Yup.number().required("Value must be greater than or equal to 1.").min(1, "Value must be greater than or equal to 1.").max(100, "Value must be less than or equal to 100."),
        job_owner_emails: Yup.array().min(1, TRANSLATION('common:errors:owner_required')),
        approvers: Yup.object().shape({  emails: Yup.array(),
                                                required_approvers: Yup.string().when('emails', {is: (emails) => {return emails.length > 0},
                                                then: Yup.string().required(TRANSLATION('common:errors:required')) })}),
        screening_questions_attributes: Yup.array().of(
          Yup.object().shape({
             _destroy: Yup.boolean(),
            mandatory: Yup.boolean(),
            option_mandatory: Yup.boolean(),
            question: Yup.string().when("_destroy",{
              is: (_destroy) => !_destroy,
              then: Yup.string().nullable(true).required(TRANSLATION('common:errors:enter_queston'))
            }),
            question_type_id: Yup.string().when("_destroy",{
              is: (_destroy) => !_destroy,
              then: Yup.string().nullable(true).required(TRANSLATION('common:errors:select_answer_type'))
            }),
            question_type_name: Yup.string(),
            question_options_attributes: Yup.array().when(['_destroy', 'option_mandatory'], {
              is: (_destroy, option_mandatory) => !_destroy && option_mandatory,
              then: Yup.array().of(
                Yup.object({
                  _destroy: Yup.boolean(),
                  option: Yup.string().when("_destroy",{
                    is: (_destroy) => {
                      return !_destroy
                    },
                    then: Yup.string().nullable(true).required(TRANSLATION('common:errors:enter_anwser_option')),
                    otherwise: Yup.string().notRequired()
                  })
                })
              )
            })
          })
        ),
      })
    })
  }
  else{
    return Yup.object().shape({})
  }
}
